import React from 'react'
import {
    StyledIconVideo,
    StyledIconVideo2,
    StyledIconImage,
} from './FigCaption.styled'
import { colors } from '../../__styling/settings/colors'
import { Product } from '@news-mono/web-common'

export function getTypeAndIcon(
    showMediaIcon: boolean,
    product: Product,
    kind: string | undefined,
    captionText: string | undefined,
) {
    let mediaType = null
    let mediaIcon = null

    if (showMediaIcon) {
        mediaType = captionText ? ' Credit: ' : 'Credit: '

        if (kind === 'video') {
            if (product === 'perthnow') {
                mediaIcon = <StyledIconVideo />
            } else {
                mediaIcon = (
                    <StyledIconVideo2
                        width={17}
                        height={15}
                        fill={colors.thewest.greyKoala}
                    />
                )
            }
        } else if (kind === 'image') {
            mediaIcon = <StyledIconImage />
        } else if (kind === 'hero-image') {
            mediaType = 'Main Image: '
            mediaIcon = <StyledIconImage />
        }
    }

    if (product === 'sevennews') {
        mediaIcon = null
    }
    return { mediaType, mediaIcon }
}
